module.exports = __webpack_public_path__ + "static/img/核心服务@2x.da996bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/核心服务@2x.png
// module id = boGS
// module chunks = 0